import { z } from "zod";
export const SELF_HOSTED_EXPERIMENT_MODE = "self_hosted";
export const SELF_HOSTED_SYNTHETIC_PROMPT = "Reply with exactly SELF_HOSTED_READY and nothing else.";
export const SELF_HOSTED_EXPERIMENT_ADMIN_EMAIL = "george.pullen@mercurylabs.io";
export const SELF_HOSTED_EXPERIMENT_MODEL = "Qwen/Qwen3.5-35B-A3B-GPTQ-Int4@3af5ca2972faf6de1fd6f4efc4d8d319ca751e8b";
export const VENUS_EXPERIMENT_MODEL = "Qwen/Qwen3.6-35B-A3B-FP8@95a723d08a9490559dae23d0cff1d9466213d989";
export const VENUS_QWEN38_VERDA_MODEL = "unsloth/Qwen3.8-27B-GGUF/Qwen3.8-27B-UD-Q5_K_XL.gguf@4ca720788d1e01f1bff70c033e0d0028fd02e502";
// HPT cycle-2 research adapter: pinned Qwen3.8-27B base + frozen 98-case LoRA
// (rank-16, compact-actions-adapter-v1) merged to BF16 and quantized for the
// same llama.cpp appliance path. Research-mirror only; never a product route.
export const VENUS_QWEN38_CYCLE2_LORA_VERDA_MODEL = "mlx/qwen3.8-27b-cycle2-lora@1";
// GPU-specific artifacts share a versioned route; serving-profile provides exact provenance.
export const VENUS_QWEN38_MODAL_MODEL = "mlx/qwen3.8-27b-modal@2";
export const VENUS_QWEN38_DFLASH2_VERDA_MODEL = "z-lab/Qwen3.8-27B-DFlash2@50307d4c4cde6860d4eee73e2547cd786fe8e8a4";
export const VENUS_QWEN38_DFLASH2_TARGET_MODEL = "Qwen/Qwen3.8-27B@1d4bf0f2ff6012fd82039f2fa52739d0dd7c60c0";
export const VENUS_QWEN38_CUSTOM_KERNEL_VERDA_MODEL = "mlx/qwen3.8-27b-custom-kernel@1";
/** Parent-only production route for the pinned Qwen3.8 Modal deployment. */
export const PROJECT_VENUS_MODEL = "mlx/project-venus@1";
export const VENUS_NOVA_MODEL = "mlx/venus-nova@1";
/** Composite production route: Qwen3.8 parent plus the bounded Qwen3.6 explorer pool. */
export const VENUS_DEEP_SPACE_MODEL = "mlx/venus-deep-space@1";
/** Exact logical identity used only by Deep Space retrieval children. */
export const VENUS_DEEP_SPACE_EXPLORER_MODEL = "mlx/qwen3.6-35b-a3b-explorer@2";
/** Temporary explicit migration identity; remove after all explorer targets reach @2. */
export const VENUS_DEEP_SPACE_NINFER_EXPLORER_MODEL = "mlx/qwen3.6-35b-a3b-explorer@1";
export function getVenusDeepSpaceExplorerModel(env) {
    const model = env.MLX_VENUS_EXPLORER_MODEL?.trim() || VENUS_DEEP_SPACE_EXPLORER_MODEL;
    if (!isVenusDeepSpaceExplorerModel(model))
        throw new Error("MLX_VENUS_EXPLORER_MODEL must be the exact explorer @1 or @2 identity");
    return model;
}
export const PROJECT_VENUS_PARENT_MODEL = VENUS_QWEN38_MODAL_MODEL;
export const VENUS_QWEN38_SGLANG_NVFP4_VERDA_MODEL = "mlx/qwen3.8-27b-sglang-nvfp4@1";
export const VENUS_QWEN38_SGLANG_NVFP4_DFLASH2_VERDA_MODEL = "mlx/qwen3.8-27b-sglang-nvfp4-dflash2@1";
export const VENUS_QWEN38_VLLM_NVFP4_VERDA_MODEL = "mlx/qwen3.8-27b-vllm-nvfp4@1";
export const VENUS_QWEN38_VLLM_NVFP4_DFLASH2_VERDA_MODEL = "mlx/qwen3.8-27b-vllm-nvfp4-dflash2@1";
export const VENUS_QWEN38_QUASAR_MODAL_MODEL = "mlx/qwen3.8-27b-quasar-nvfp4-vllm@1";
export const VENUS_QWEN38_QUASAR_TARGET_MODEL = "QUASAR-QAT/Qwen3.8-27B-QUASAR-NVFP4@d8e6fbfa3e3a78899b440222b827430045a05b44";
export const VENUS_QWEN38_NVFP4_TARGET_MODEL = "RadixArk/Qwen3.8-27B-NVFP4@319f741cce68d7914884900c138a1fbb70a42f30";
export const VENUS_A3_EXPERIMENT_MODEL = "mercurylabs-ai/beaver-qwen36-35b-a3b-attn-lora-20260803@4c732a913c70f610382b2b0e75d0aa7eefaec051";
// Server-owned logical route identity. The provider request never receives
// this value: Pi maps actions to the pinned private Warehouse adapter and maps
// finalisation back to VENUS_EXPERIMENT_MODEL.
export const VENUS_WAREHOUSE_RUNPOD_MODEL = "mlx/venus-v0.2-runpod-serverless@1";
export const VENUS_EXPERIMENT_MODELS = new Set([
    VENUS_EXPERIMENT_MODEL,
    VENUS_QWEN38_VERDA_MODEL,
    VENUS_QWEN38_CYCLE2_LORA_VERDA_MODEL,
    VENUS_QWEN38_DFLASH2_VERDA_MODEL,
    VENUS_QWEN38_CUSTOM_KERNEL_VERDA_MODEL,
    PROJECT_VENUS_MODEL,
    VENUS_NOVA_MODEL,
    VENUS_DEEP_SPACE_MODEL,
    VENUS_DEEP_SPACE_EXPLORER_MODEL,
    VENUS_DEEP_SPACE_NINFER_EXPLORER_MODEL,
    VENUS_QWEN38_SGLANG_NVFP4_VERDA_MODEL,
    VENUS_QWEN38_SGLANG_NVFP4_DFLASH2_VERDA_MODEL,
    VENUS_QWEN38_VLLM_NVFP4_VERDA_MODEL,
    VENUS_QWEN38_VLLM_NVFP4_DFLASH2_VERDA_MODEL,
    VENUS_QWEN38_QUASAR_MODAL_MODEL,
    VENUS_A3_EXPERIMENT_MODEL,
    VENUS_WAREHOUSE_RUNPOD_MODEL,
]);
export const SELF_HOSTED_EXPERIMENT_MODELS = new Set([
    SELF_HOSTED_EXPERIMENT_MODEL,
    VENUS_EXPERIMENT_MODEL,
    VENUS_QWEN38_VERDA_MODEL,
    VENUS_QWEN38_CYCLE2_LORA_VERDA_MODEL,
    VENUS_QWEN38_DFLASH2_VERDA_MODEL,
    VENUS_QWEN38_CUSTOM_KERNEL_VERDA_MODEL,
    PROJECT_VENUS_MODEL,
    VENUS_NOVA_MODEL,
    VENUS_DEEP_SPACE_MODEL,
    VENUS_DEEP_SPACE_EXPLORER_MODEL,
    VENUS_DEEP_SPACE_NINFER_EXPLORER_MODEL,
    VENUS_QWEN38_SGLANG_NVFP4_VERDA_MODEL,
    VENUS_QWEN38_SGLANG_NVFP4_DFLASH2_VERDA_MODEL,
    VENUS_QWEN38_VLLM_NVFP4_VERDA_MODEL,
    VENUS_QWEN38_VLLM_NVFP4_DFLASH2_VERDA_MODEL,
    VENUS_QWEN38_QUASAR_MODAL_MODEL,
]);
export const VENUS_QWEN38_PROVIDER_STACK_MODELS = new Set([
    VENUS_QWEN38_SGLANG_NVFP4_VERDA_MODEL,
    VENUS_QWEN38_SGLANG_NVFP4_DFLASH2_VERDA_MODEL,
    VENUS_QWEN38_VLLM_NVFP4_VERDA_MODEL,
    VENUS_QWEN38_VLLM_NVFP4_DFLASH2_VERDA_MODEL,
]);
export const VENUS_QWEN38_VERDA_MODELS = new Set([
    VENUS_QWEN38_VERDA_MODEL,
    VENUS_QWEN38_CYCLE2_LORA_VERDA_MODEL,
    VENUS_QWEN38_DFLASH2_VERDA_MODEL,
    VENUS_QWEN38_CUSTOM_KERNEL_VERDA_MODEL,
    VENUS_QWEN38_SGLANG_NVFP4_VERDA_MODEL,
    VENUS_QWEN38_SGLANG_NVFP4_DFLASH2_VERDA_MODEL,
    VENUS_QWEN38_VLLM_NVFP4_VERDA_MODEL,
    VENUS_QWEN38_VLLM_NVFP4_DFLASH2_VERDA_MODEL,
]);
export function venusContextWindowTokens(model) {
    if (model === VENUS_NOVA_MODEL)
        return 65_536;
    // The A100 fallback qualifies 64K; never admit a prompt it cannot serve.
    if (model === PROJECT_VENUS_MODEL || model === VENUS_DEEP_SPACE_MODEL)
        return 65_536;
    if (model === SELF_HOSTED_EXPERIMENT_MODEL)
        return 32_768;
    if (model === VENUS_EXPERIMENT_MODEL ||
        model === VENUS_A3_EXPERIMENT_MODEL ||
        model === VENUS_WAREHOUSE_RUNPOD_MODEL) {
        return 40_960;
    }
    if (model === VENUS_QWEN38_VERDA_MODEL)
        return 1_048_576;
    if (model === VENUS_QWEN38_CYCLE2_LORA_VERDA_MODEL)
        return 1_048_576;
    if (model === VENUS_QWEN38_DFLASH2_VERDA_MODEL ||
        model === VENUS_QWEN38_CUSTOM_KERNEL_VERDA_MODEL ||
        model === VENUS_QWEN38_QUASAR_MODAL_MODEL ||
        VENUS_QWEN38_PROVIDER_STACK_MODELS.has(String(model))) {
        return 65_536;
    }
    return undefined;
}
export function isVenusQwen38VerdaModel(model) {
    return typeof model === "string" && VENUS_QWEN38_VERDA_MODELS.has(model);
}
export function isVenusQwen38ProviderStackModel(model) {
    return typeof model === "string" && VENUS_QWEN38_PROVIDER_STACK_MODELS.has(model);
}
export function isVenusExperimentModel(model) {
    return typeof model === "string" && VENUS_EXPERIMENT_MODELS.has(model);
}
export function isProjectVenusModel(model) {
    return model === PROJECT_VENUS_MODEL;
}
export function isVenusDeepSpaceModel(model) {
    return model === VENUS_DEEP_SPACE_MODEL;
}
export function isVenusDeepSpaceExplorerModel(model) {
    return model === VENUS_DEEP_SPACE_EXPLORER_MODEL || model === VENUS_DEEP_SPACE_NINFER_EXPLORER_MODEL;
}
export function isVenusProductionModel(model) {
    return model === VENUS_NOVA_MODEL || isProjectVenusModel(model) || isVenusDeepSpaceModel(model);
}
/** Logical Modal routes that use the thin Qwen3.8 Venus harness. */
export function isVenusModalHarnessModel(model) {
    return isVenusProductionModel(model) ||
        model === VENUS_QWEN38_QUASAR_MODAL_MODEL;
}
export function isProjectVenusModalModelConfig(config) {
    return config?.executor?.provider === "modal" &&
        isVenusProductionModel(config.executor.model);
}
export const PROJECT_VENUS_CAPABILITY_TOOL_NAMES = [
    "venus_capability_search",
    "venus_capability_invoke",
];
export function isProjectVenusCapabilityToolName(value) {
    return typeof value === "string" &&
        PROJECT_VENUS_CAPABILITY_TOOL_NAMES.some((name) => name === value);
}
/*
 * Venus family membership is derived from the execution provider, not from a
 * per-model allowlist. The pinned model constants above stay authoritative for
 * the sealed-experiment env validation only.
 */
export const VENUS_RUNTIME_PROVIDERS = new Set(["runpod", "verda", "modal"]);
export function isVenusRuntimeProvider(provider) {
    return typeof provider === "string" &&
        VENUS_RUNTIME_PROVIDERS.has(provider);
}
/** Production Venus is enabled independently from experimental provider lanes. */
export function projectVenusModalSelectionEnabled(env) {
    return env.MLX_VENUS_MODAL_ENABLED?.trim().toLowerCase() === "true";
}
export function venusNovaSelectionEnabled(env) {
    return env.MLX_VENUS_NOVA_ENABLED?.trim().toLowerCase() === "true";
}
/** Deep Space is an explicit target capability because it requires two exact pools. */
export function venusDeepSpaceSelectionEnabled(env) {
    return projectVenusModalSelectionEnabled(env) &&
        env.MLX_VENUS_DEEP_SPACE_ENABLED?.trim().toLowerCase() === "true";
}
/** The isolated Modal QUASAR lane is hidden unless target config enables it. */
export function venusQuasarModalSelectionEnabled(env) {
    return env.MLX_VENUS_QUASAR_MODAL_ENABLED?.trim().toLowerCase() === "true";
}
/** The Verda path stays hidden until its inference endpoint is provisioned. */
export function venusVerdaSelectionEnabled(env) {
    return env.MLX_VENUS_VERDA_ENABLED?.trim().toLowerCase() === "true" ||
        venusVerdaOnDemandEnabled(env);
}
export function venusVerdaOnDemandEnabled(env) {
    return env.MLX_VENUS_VERDA_ON_DEMAND_ENABLED?.trim().toLowerCase() === "true";
}
/** The custom-kernel picker and capacity route stay sealed until its appliance is verified. */
export function venusCustomKernelSelectionEnabled(env) {
    return venusVerdaSelectionEnabled(env) &&
        env.MLX_VENUS_CUSTOM_KERNEL_ENABLED?.trim().toLowerCase() === "true";
}
/** Allows sealed R&D evaluation without exposing the custom kernel in the picker. */
export function venusCustomKernelEvaluationEnabled(env) {
    return venusVerdaSelectionEnabled(env) &&
        env.MLX_VENUS_CUSTOM_KERNEL_EVALUATION_ENABLED?.trim().toLowerCase() ===
            "true";
}
export function venusCustomKernelAdmissionEnabled(env) {
    return venusCustomKernelSelectionEnabled(env) ||
        venusCustomKernelEvaluationEnabled(env);
}
/** The four native NVFP4 engine profiles share one separately gated appliance. */
export function venusProviderStacksSelectionEnabled(env) {
    return venusVerdaSelectionEnabled(env) &&
        env.MLX_VENUS_PROVIDER_STACKS_ENABLED?.trim().toLowerCase() === "true";
}
/** The Warehouse-v1 Runpod endpoint is an independently gated slow path. */
export function venusRunpodWarehouseSelectionEnabled(env) {
    return env.MLX_VENUS_RUNPOD_WAREHOUSE_ENABLED?.trim().toLowerCase() === "true";
}
export function venusProviderModelSelectionEnabled(provider, model, env) {
    if (provider === "modal") {
        return model === VENUS_NOVA_MODEL
            ? venusNovaSelectionEnabled(env)
            : model === PROJECT_VENUS_MODEL
                ? projectVenusModalSelectionEnabled(env)
                : model === VENUS_DEEP_SPACE_MODEL
                    ? venusDeepSpaceSelectionEnabled(env)
                    : model === VENUS_QWEN38_QUASAR_MODAL_MODEL &&
                        venusQuasarModalSelectionEnabled(env);
    }
    if (provider === "verda") {
        return isVenusQwen38VerdaModel(model) && venusVerdaSelectionEnabled(env) &&
            (model !== VENUS_QWEN38_CUSTOM_KERNEL_VERDA_MODEL ||
                venusCustomKernelSelectionEnabled(env)) &&
            (!isVenusQwen38ProviderStackModel(model) ||
                venusProviderStacksSelectionEnabled(env));
    }
    if (provider !== "runpod")
        return false;
    if (model === SELF_HOSTED_EXPERIMENT_MODEL)
        return true;
    if (!isVenusExperimentModel(model))
        return false;
    return model === VENUS_WAREHOUSE_RUNPOD_MODEL
        ? venusRunpodWarehouseSelectionEnabled(env)
        : model === VENUS_EXPERIMENT_MODEL || model === VENUS_A3_EXPERIMENT_MODEL;
}
export function venusProviderModelAdmissionEnabled(provider, model, env) {
    if (provider === "verda" && model === VENUS_QWEN38_CUSTOM_KERNEL_VERDA_MODEL) {
        return isVenusQwen38VerdaModel(model) && venusVerdaSelectionEnabled(env) &&
            venusCustomKernelAdmissionEnabled(env);
    }
    return venusProviderModelSelectionEnabled(provider, model, env);
}
export function venusExperimentConfigAllowsModel(configuredModel, provider, requestedModel) {
    if (configuredModel === PROJECT_VENUS_MODEL &&
        (requestedModel === VENUS_DEEP_SPACE_MODEL || requestedModel === VENUS_NOVA_MODEL)) {
        return provider === "modal";
    }
    if (provider === "modal" && requestedModel === VENUS_QWEN38_QUASAR_MODAL_MODEL) {
        return configuredModel === PROJECT_VENUS_MODEL ||
            configuredModel === VENUS_QWEN38_QUASAR_MODAL_MODEL;
    }
    if (configuredModel === PROJECT_VENUS_MODEL) {
        return requestedModel === PROJECT_VENUS_MODEL ||
            (provider === "verda" && isVenusQwen38VerdaModel(requestedModel)) ||
            (provider === "runpod" && isVenusExperimentModel(requestedModel));
    }
    if (configuredModel === VENUS_EXPERIMENT_MODEL) {
        return isVenusExperimentModel(requestedModel);
    }
    if (provider === "verda" && isVenusQwen38VerdaModel(configuredModel)) {
        return isVenusQwen38VerdaModel(requestedModel);
    }
    return typeof configuredModel === "string" && requestedModel === configuredModel;
}
export const selfHostedExperimentModeSchema = z.literal(SELF_HOSTED_EXPERIMENT_MODE);
/*
 * The Venus role is the set of operators allowed to select a Venus model and
 * read Venus run configuration. It is target configuration (a comma-separated
 * allowlist), so granting it to another teammate is a config change plus a
 * deploy — no product-code edit and no tenant-specific constant.
 */
export function parseSelfHostedAdminEmails(raw) {
    return [
        ...new Set((raw ?? "")
            .split(",")
            .map((entry) => entry.trim().toLowerCase())
            .filter(Boolean)),
    ];
}
export function selfHostedExperimentFeatureConfig(env) {
    const enabled = env.MLX_SELF_HOSTED_EXPERIMENT_ENABLED?.trim().toLowerCase();
    if (!enabled || enabled === "false")
        return { status: "disabled" };
    if (enabled !== "true") {
        return { status: "misconfigured", reason: "enabled must be true or false" };
    }
    if (env.MLX_SELF_HOSTED_TASK_DATA_ENABLED?.trim().toLowerCase() !== "true") {
        return {
            status: "misconfigured",
            reason: "enabled requires explicit task-data authorization",
        };
    }
    const adminEmails = parseSelfHostedAdminEmails(env.MLX_SELF_HOSTED_EXPERIMENT_ADMIN_EMAIL);
    if (adminEmails.length === 0) {
        return {
            status: "misconfigured",
            reason: "enabled requires at least one admin email",
        };
    }
    if (!adminEmails.every((email) => z.string().email().safeParse(email).success)) {
        return {
            status: "misconfigured",
            reason: "enabled requires every admin email to be valid",
        };
    }
    const model = env.MLX_SELF_HOSTED_MODEL?.trim();
    if (!model || !SELF_HOSTED_EXPERIMENT_MODELS.has(model)) {
        return {
            status: "misconfigured",
            reason: "enabled requires the pinned self-hosted experiment model",
        };
    }
    const rawMaxRuns = env.MLX_SELF_HOSTED_EXPERIMENT_MAX_RUNS?.trim();
    const maxRuns = Number(rawMaxRuns);
    if (!rawMaxRuns || !Number.isInteger(maxRuns) || maxRuns < 1 || maxRuns > 11) {
        return {
            status: "misconfigured",
            reason: "enabled requires max runs between 1 and 11",
        };
    }
    const rawAccess = env.MLX_SELF_HOSTED_EXPERIMENT_ACCESS?.trim().toLowerCase() ||
        "admins";
    if (rawAccess !== "admins" &&
        rawAccess !== "organisation_admins" &&
        rawAccess !== "organisation") {
        return {
            status: "misconfigured",
            reason: "access must be admins, organisation_admins, or organisation",
        };
    }
    return { status: "enabled", adminEmails, access: rawAccess, model, maxRuns };
}
export function selfHostedExperimentUserAllowed(config, input) {
    if (config.status !== "enabled")
        return false;
    if (input.emailVerified === false)
        return false;
    if (config.access === "organisation")
        return true;
    if (config.access === "organisation_admins") {
        return input.isOrganisationAdmin;
    }
    const email = input.email?.trim().toLowerCase();
    if (!email)
        return false;
    return input.isOrganisationAdmin && config.adminEmails.includes(email);
}
